// action types

const DISABLE_REDIRECTION = 'PUSHER_DISABLE_REDIRECTION';
const ENABLE_REDIRECTION = 'PUSHER_ENABLE_REDIRECTION';

// reducer

const initialState = {
  isRedirectionEnabled: true,
};

const pusher = (state = initialState, action) => {
  switch (action.type) {
    case ENABLE_REDIRECTION:
      return { ...state, isRedirectionEnabled: true };
    case DISABLE_REDIRECTION:
      return { ...state, isRedirectionEnabled: false };
    default:
      return { ...state };
  }
};

export default pusher;

// action creators

export const enablePusherRedirection = () => dispatch => dispatch({ type: ENABLE_REDIRECTION });

export const disablePusherRedirection = () => dispatch => dispatch({ type: DISABLE_REDIRECTION });
